import { Component } from 'react';
import { IbssComponent } from '../../../../Components/Core/BaseComponent/IbssComponent';
import { Box, Card, Skeleton, TextField, Typography } from '@mui/material';
import { GetCateringStatus } from '../../../OneLens/CateringOrders/List/CateringStatus'; // todo: shouldn't be referncing different page
import { appContext } from '../../../../AppContext';
import IbssTimePicker from '../../../../Components/Inputs/TimePicker/IbssTimePicker';
import { DateTime } from 'luxon';
import IbssSvgIcon from '../../../../Components/Icons/SvgIcon/IbssSvgIcon';
import IbssButton from '../../../../Components/Buttons/Button/IbssButton';
import { Icons } from '../../../../Common/AllsvgIcons';
import { CateringMenuItemView, ICateringRestrictionView } from './EditCateringOrder';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import IbssInputDropDown from '../../../../Components/Inputs/SelectList/IbssInputDropDown';
import IbssSwitchLabel from '../../../../Components/Inputs/Switch/IbssSwitchLabel';

class OrderSummaryPanel extends IbssComponent<IProps, IState>
{
    private get labels() { return appContext().labels; }
    private get appState() { return appContext().state; }

    constructor(props: IProps)
    {
        super(props);
        this.state =
        {
        };
    };

    private getSelectedRestrictionNames(): string
    {
        const selectedRestrictionIds = this.props.selectedRestrictions.map(x => x.id)
        const selectedRestrictions = this.props.cateringRestrictions.filter(x => selectedRestrictionIds.includes(x.id));
        return selectedRestrictions.map(x => x.name).toString();
    }

    public render(): JSX.Element
    {
        const cateringStatus = new GetCateringStatus({});
        const nonCancellableCateringOrderStatuses = ['Delivered', 'Cleared', 'Completed', 'CancellationPending', 'CancelledNoCharge', 'CancelledCharged'];       
        const pastCutOffPeriod = this.props.pastCutOffPeriod;
        const cateringCutoffValidationFail = pastCutOffPeriod && !this.props.userHasIgnoreCateringCutoffRights;

        const selectedServiceTimeError = (this.props.cateringServiceTime < this.props.bookingStart) || (this.props.cateringServiceTime > this.props.bookingEnd);
        const selectedCleanUpTimeError = (this.props.cateringClearingTime < this.props.bookingStart) || (this.props.cateringClearingTime > this.props.bookingEnd);
        const serviceTimeGreaterThanClearUpTime = (this.props.cateringServiceTime) > this.props.cateringClearingTime;
        const itemTotal = this.props.orderItems?.map(x => x.quantity).reduce((x, y) => { return x + y }, 0);
        const orderTotalCost = this.props.orderItems?.map(x => x.quantity*x.unitPrice).reduce((x, y) => { return x + y }, 0);
        const disableSubmitButton = (itemTotal == 0 || isNaN(orderTotalCost) || selectedServiceTimeError || selectedCleanUpTimeError || serviceTimeGreaterThanClearUpTime || cateringCutoffValidationFail || !this.props.cateringServiceTime || !this.props.cateringClearingTime);
        const disableCancelButton = this.props.newOrder || (!this.props.userCateringCancelRights) || nonCancellableCateringOrderStatuses.includes(this.props.cateringStatus);
        const orderHasUnavailableMenuItem = this.props.orderItems.find(orderItem => !this.props.availableMenuItemIds.includes(orderItem.menuItemId)); // order has item that isn't on available menus
        const orderHasUnavailableToOrderItemsByPolicy = this.props.orderItems.find(orderItem => orderItem.availableToOrderByPolicy === false); // order has item that has availableToOrderByPolicy property set to false.

        return (
            <Card>
                {
                    this.props.skeletonLoad ?
                        <SummaryCardSkeleton />
                        :
                        <Box sx={{ p: 4 }}>
                            <Box className="d-flex" sx={{ justifyContent: 'space-between', pb: 2 }}>
                                <Typography variant="h6" gutterBottom>{this.props.newOrder ? this.labels.funcEditCateringOrderNewOrder_S : this.props.orderName}</Typography>
                                {
                                    !this.props.newOrder &&
                                    <div>{cateringStatus.renderTaskOverAllStatus(this.props.cateringStatus, this.props.orderIsDisabled)}</div>
                                }
                            </Box>
                            <IbssInputDropDown 
                                id={'menusDropdown'}
                                value={this.props.selectedMenu}
                                options={this.props.availableMenus}
                                inputLabel={this.labels.HubLabelSelectMenu}
                                onChange={e => this.props.selectMenu(e.target.value)} 
                            />

                            <Typography variant="subtitle1" display="block" gutterBottom>{this.labels.funcCateringSingleMenu_L}</Typography>
                            {!this.props.newOrder && this.props.orderIsAutomated &&
                                <IbssSwitchLabel
                                    id={'disableCateringOrder'}
                                    checked={this.props.orderIsDisabled}
                                    label={this.labels.funcCateringDisableOrder_S}
                                    onChange={(event) => this.props.disableAutomatedOrder(event.target.checked)}
                                />
                            }
                            <Box className="mt-1" sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                <Typography variant="overline" fontSize={14} display="block" gutterBottom>{`${itemTotal} ${this.labels.HubLabelItemsSelected}`}</Typography>
                            </Box>

                                <div>
                                    {this.props.orderItems.filter(item => item.quantity > 0).map(item =>
                                    (
                                        <Box
                                            id={item.menuItemId}
                                            sx=
                                            {{ 
                                                display: "flex", 
                                                justifyContent: "space-between", 
                                                alignItems: "center", 
                                                color: (theme) => item.availableToOrderByPolicy? 'inherit': theme.palette.error.main,
                                                backgroundColor: (theme) => this.props.availableMenuItemIds.find(id => id === item.menuItemId)? 'inherit' : theme.palette.background.paper,
                                            }}
                                        >
                                            <Typography variant='body1'>{`${item.quantity}x  ${item.name}`}</Typography>
                                            <Typography variant='body1'> {`${this.props.currency}${(item.retailPrice * item.quantity).toFixed(2)}`}</Typography>
                                        </Box>
                                    )
                                    )}
                                </div>
                            
                            <Box className="mt-1" sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                <Typography variant="overline" fontSize={14} display="block" gutterBottom>{this.labels.funcEditCateringOrderOrderTotal_S}:</Typography>
                                <Typography variant="h6" display="block" gutterBottom>{`${this.props.currency}${this.props.orderItems?.map(x => x.retailPrice * x.quantity).reduce((x, y) => { return x + y }, 0).toFixed(2)}`}</Typography>
                            </Box>
                            
                            {(orderHasUnavailableMenuItem || orderHasUnavailableToOrderItemsByPolicy) &&
                                <Typography className='mt-1'>
                                    {this.labels.funcCateringUnavailableItems_D}
                                </Typography>
                            }

                            <Box className='mt-1' sx={{ display: 'flex', gap: 1, alignItems:'center', flexWrap: 'wrap' }}>
                                <Typography variant="subtitle1" display="block">{this.labels.funcCateringAllergies_L}:</Typography>
                                <div style={{ cursor: 'pointer', color: '#4380cb', display: 'flex', flexWrap: 'wrap' }} onClick={() => this.props.displayRestrictionsModal()}>{this.props.selectedRestrictions.length == 0 ? `${this.labels.HubButtonAdd} +` : this.getSelectedRestrictionNames()}</div>
                            </Box>

                            <div>
                                <TextField
                                    id="outlined-multiline-static"
                                    multiline
                                    disabled={cateringCutoffValidationFail}
                                    color="secondary"
                                    placeholder={this.labels.funcNotesAdd_S}
                                    value={this.props.cateringNotes}
                                    rows={4}
                                    sx={{ '& legend': { display: 'none' }, '& fieldset': { top: 0 } }}
                                    fullWidth
                                    onChange={e => this.props.onNotesChange(e.target.value)}
                                />
                            </div>
                            {!this.props.allOrderedItemsAvailable && (
                                <Box sx={{backgroundColor: '#fff3cd', border: '1px solid #ffeeba', color: '#856404', padding: 2, marginBottom: 2, borderRadius: 1, display: 'flex', alignItems: 'center'}}>
                                    <Typography>
                                        {this.labels.functReviewYourOrder_L}                                   
                                    </Typography>
                                </Box>
                            )}
                            
                            <Box component="div" sx={{ marginTop: '16px', display: 'flex', justifyContent: 'space-around' }}>
                                <Box style={{ alignSelf: 'center' }}>
                                    <div style={{ fontSize: '20px' }}>
                                        <IbssTimePicker
                                            label={this.labels.HubLabelServiceTime}
                                            minTime={this.props.bookingStart}
                                            maxTime={this.props.bookingEnd}
                                            className='ibss-timepicker'
                                            value={this.props.cateringServiceTime}
                                            onChange={e => e !== null ? this.props.onCateringServiceTimeChange(new Date(e.toJSDate())) : {}}
                                            ampm={false}
                                            minutesStep={1}
                                            disabled={cateringCutoffValidationFail}
                                            onOpen={() => this.props.serviceTimePickerOpened()}
                                            slotProps={{
                                                textField: {
                                                    error: selectedServiceTimeError || serviceTimeGreaterThanClearUpTime || !this.props.cateringServiceTime,
                                                    fullWidth: true,
                                                    onFocus:() => this.props.serviceTimePickerInFocus(),
                                                }
                                            }}
                                        />
                                    </div>
                                </Box>
                                <div
                                    className="icon-text-inline"
                                    style={{
                                        padding: "10px 22px",
                                    }}>
                                        <IbssSvgIcon fontSize='large'>{Icons.RightArrow}</IbssSvgIcon>
                                   </div>
                                <div style={{ alignSelf: 'center' }}>
                                    <div style={{ fontSize: '23px' }}>
                                        <IbssTimePicker
                                            label={this.labels.funcCateringCleanUpTime_S}
                                            minTime={this.props.bookingStart}
                                            maxTime={this.props.bookingEnd}
                                            className='ibss-timepicker'
                                            value={this.props.cateringClearingTime}
                                            onChange={e => e !== null ? this.props.onCateringClearingTimeChange(new Date(e.toJSDate())) : {}}
                                            ampm={false}
                                            minutesStep={1}
                                            slotProps={{ textField: { error: selectedCleanUpTimeError || serviceTimeGreaterThanClearUpTime || !this.props.cateringClearingTime, fullWidth: true } }}
                                            disabled={cateringCutoffValidationFail}
                                        />
                                    </div>
                                </div>
                            </Box>
                            <div className='d-flex justify-content-between'>
                                <IbssButton color="secondary" variant="contained" onClick={() => this.props.cancelChangesClicked()}>{this.labels.HubLabelCancelChanges}</IbssButton>
                                <IbssButton 
                                    disabled={disableSubmitButton} 
                                    variant="contained" 
                                    onClick={() => this.props.newOrder ? this.props.createClicked() : this.props.updateClicked()}
                                >
                                    {this.labels.funcCateringSaveOrder_S}
                                </IbssButton>
                            </div>
                            <div className='mt-1'>
                                <IbssButton 
                                    disabled={disableCancelButton}
                                    color='error' 
                                    variant="contained" 
                                    onClick={() => this.props.cancelOrderClicked()}
                                    fullWidth
                                >
                                    {this.labels.funcCateringCancelOrder_S}
                                </IbssButton>
                            </div>
                        </Box>
                }

            </Card>
        )
    }
}

export default OrderSummaryPanel;

export interface IProps
{
    bookingName: string;
    bookingStart: DateTime;
    bookingEnd: DateTime;
    orderName: string;
    preBookCateringTime: string;
    buildingId: number;
    cateringServiceTime: DateTime;
    cateringClearingTime: DateTime;
    skeletonLoad: boolean;
    newOrder: boolean
    cateringStatus: string;
    onCateringServiceTimeChange: (date: Date) => void;
    onCateringClearingTimeChange: (date: Date) => void;
    onNotesChange: (value: string) => void;
    hasUnavailableMenu: boolean;
    cateringNotes: string;
    orderItems: CateringMenuItemView[];
    currency: string;
    displayRestrictionsModal: () => void;
    selectedRestrictions: ICateringRestrictionView[];
    cateringRestrictions: ICateringRestrictionView[];
    createClicked: () => void;
    cancelChangesClicked: () => void;
    cancelOrderClicked: () => void;
    updateClicked: () => void;
    availableMenuItemIds: string[];
    availableMenus: IDropdownOptions[];
    selectMenu: (value: string) => void;
    selectedMenu: string;
    pastCutOffPeriod: boolean;
    userHasCateringRights: boolean;
    userHasIgnoreCateringCutoffRights: boolean;
    userCateringCancelRights: boolean;
    serviceTimePickerOpened: () => void;
    serviceTimePickerInFocus: () => void;
    allOrderedItemsAvailable: boolean;
    orderIsAutomated: boolean;
    orderIsDisabled: boolean;
    disableAutomatedOrder: (disable: boolean) => void;
}

export interface IState
{
}

export class SummaryCardSkeleton extends Component
{
    public render(): JSX.Element
    {
        return (
            <div style={{ width: '100%', padding: '10px', height: '450px' }}>
                <Skeleton sx={{ margin: '20px 0px' }} variant="rectangular" width={'50%'} height={10} />
                <div style={{ textAlign: 'center' }}>
                    <Skeleton variant="rectangular" width={'95%'} height={100} />
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-evenly', marginTop: '10px' }}>
                    <Skeleton sx={{ margin: '5px 5px' }} variant="rectangular" width={'35%'} height={10} />
                    <Skeleton sx={{ margin: '5px 5px' }} variant="rectangular" width={'35%'} height={10} />
                </div>
                <Skeleton sx={{ margin: '20px 0px' }} variant="rectangular" width={'70%'} height={10} />
                <div style={{ textAlign: 'center' }}>
                    <Skeleton variant="rectangular" width={'95%'} height={70} />
                </div>
                <div style={{ display: 'flex', marginTop: '30px' }}>
                    <Skeleton sx={{ margin: '5px 5px' }} variant="rectangular" width={'15%'} height={10} />
                    <Skeleton sx={{ margin: '5px 5px' }} variant="rectangular" width={'45%'} height={10} />
                </div>
                <div style={{ display: 'flex', marginTop: '10px' }}>
                    <Skeleton sx={{ margin: '5px 5px' }} variant="rectangular" width={'15%'} height={10} />
                    <Skeleton sx={{ margin: '5px 5px' }} variant="rectangular" width={'35%'} height={10} />
                </div>
            </div>
        )
    }
}

export interface IDropdownOptions
{
    label: string;
    value: string;
}